module.exports = __webpack_public_path__ + "static/media/holly_jolly_slots.7fd4a124.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/holly_jolly_slots.png
// module id = 313
// module chunks = 0